// components/Spinner.js - Loading spinner component
import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../lib/utils';

export const Spinner = ({ size = 'md', className }) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-8 h-8 border-3',
    xl: 'w-12 h-12 border-4'
  };
  
  return (
    <motion.div
      className={cn(
        "rounded-full border-t-transparent border-primary animate-spin",
        sizeClasses[size],
        className
      )}
      animate={{ rotate: 360 }}
      transition={{
        duration: 1,
        repeat: Infinity,
        ease: "linear"
      }}
    />
  );
};

export default Spinner;
